module.exports = __webpack_public_path__ + "img/pediatricos.47169f62.png";